export default __webpack_public_path__ + "static/media/header-1.4e7b608d.jpg";